import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#9a6b27',
        secondary: '#fbf7ee',
        accent: '#b9893f',
      },
    },
  },
});
